<template>
  <v-container grid-list-md class="py-0 px-2 ma-0">
    <v-row>
      <v-col cols="12">
        <v-layout></v-layout>
        <v-flex xs12 class="mt-2" mx-auto>
          <v-card>
            <v-form ref="sForm" @submit.prevent="SearchBOStaffSiteVisit()">
              <v-card-text class="pb-0 pt-2">
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs3>
                      <v-select
                      v-model="lAttDet.category"
                      label="Select category"
                      :items="['Active', 'Inactive']"
                      hide-details
                      outlined
                      dense
                      style="font-size: 12px"
                      ></v-select>
                    </v-flex>
                    <v-flex xs3 v-if="lAttDet.category === 'Active'">
                      <v-select
                      v-model="lAttDet.comm_id"
                      label="Community"
                      :items="commList"
                      item-text="comm_name"
                      item-value="comm_id"
                      hide-details
                      clearable
                      multiple
                      outlined
                      dense
                      style="font-size: 12px"
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index === 0">
                            <span>{{ item.comm_name }}</span>
                          </v-chip>
                          <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                          >
                          (+{{ lAttDet.comm_id.length - 1 }} others)
                          </span>
                        </template>
                      <template v-slot:prepend-item>
                        <v-list-item
                        ripple
                        @click="toggle"
                        >
                        <v-list-item-action>
                          <v-icon :color="lAttDet.comm_id && lAttDet.comm_id.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Select All</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs3 v-if="lAttDet.category === 'Inactive'">
                  <v-select
                  v-model="lAttDet.comm_id"
                  label="Community"
                  :items="inactiveCommList"
                  item-text="comm_name"
                  item-value="comm_id"
                  hide-details
                  clearable
                  multiple
                  outlined
                  dense
                  style="font-size: 12px"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text text-caption"
                      >
                      (+{{ lAttDet.comm_id.length - 1 }} others)
                      </span>
                    </template>
                  <template v-slot:prepend-item>
                    <v-list-item
                    ripple
                    @click="toggle"
                    >
                    <v-list-item-action>
                      <v-icon :color="lAttDet.comm_id && lAttDet.comm_id.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Select All</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
              v-model="lAttDet.vendor_emp_id"
              label="Employee Name"
              :items="showAllEmp ? resignedEmpList : empList"
              item-text="emp_name_with_id"
              item-value="vendor_emp_id"
              hide-details
              clearable
              outlined
              dense
              style="font-size: 12px"
              >
            </v-select>
          </v-flex>
          <v-flex xs3>
            <v-switch
            v-model="showAllEmp"
            label="Show resigned employees"
            class="mb-0 pt-0"
            style="margin-top: 10px;"
            @change="loadResignedEmployee(showAllEmp)"
            ></v-switch>
          </v-flex>
          <v-flex xs3>
            <v-dialog ref="dlgstartDt"
            persistent v-model="dlgstartDt"
            max-width="290px"
            :return-value.sync="lAttDet.from_dt">
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator"
              label="From Date"
              v-model="lAttDet.from_dt" append-icon="mdi-calendar-today"
              :rules="[rules.required]"
              style="font-size: 12px; margin-top: -17px;"
              readonly
              outlined
              dense
              v-on="on"
              hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="lAttDet.from_dt" scrollable
            first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn text @click="dlgstartDt = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgstartDt.save(lAttDet.from_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs3>
        <v-dialog ref="dlgToDate"
        persistent v-model="dlgToDate"
        max-width="290px"
        :return-value.sync="lAttDet.to_dt">
        <template v-slot:activator="{ on }">
          <v-text-field
          slot="activator"
          label="To Date"
          v-model="lAttDet.to_dt" append-icon="mdi-calendar-today"
          :rules="[rules.required]"
          style="font-size: 12px; margin-top: -17px;"
          readonly
          v-on="on"
          outlined
          dense
          hide-details
          ></v-text-field>
        </template>
        <v-date-picker v-model="lAttDet.to_dt" scrollable
        first-day-of-week="1"
        >
        <v-spacer></v-spacer>
        <v-btn text @click="dlgToDate = false">Cancel</v-btn>
        <v-btn text color="accent" @click="$refs.dlgToDate.save(lAttDet.to_dt)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-flex>
  <v-flex xs4 style="margin-top: -17px;">
    <v-card-actions>
      <v-btn small @click="clear">Clear</v-btn>
      <v-btn small type="submit" color="accent" :disabled="beingSaved">search</v-btn>
    </v-card-actions>
  </v-flex>
</v-layout>
</v-flex>
</v-card-text>
</v-form>
</v-card>
</v-flex>

<v-flex xs12 class="pt-2" grid-list-md>
  <v-card-title>
    <v-flex xs6 class="title primary--text pa-1">
      <span>Search Result ({{staffVisitDetails.length}} Records)</span>
    </v-flex>
    <v-flex xs6 class="text-right">
      <v-download-as
      :headers="staffDetHeader"
      :items="staffVisitDetails"
      title="Staff List"
      ></v-download-as>
    </v-flex>
  </v-card-title>
  <v-card>
    <v-card-text class="pa-0 ma-0">
      <v-data-table
      :headers="staffDetHeader"
      :items="staffVisitDetails"
      fixed-header
      dense
      sort-by="comm_name"
      hide-default-header
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th class="uniformtableheader white--text" style="font-size: 13px; width: 55px; text-align: Left">{{headers[0].text}}</th>
            <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: Left">{{headers[1].text}}</th>
            <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[2].text}}</th>
            <th class="uniformtableheader white--text" style="font-size: 13px; width: 240px; text-align: left">{{headers[3].text}}</th>
            <th class="uniformtableheader white--text" style="font-size: 13px; width: 240px; text-align: left">{{headers[4].text}}</th>
            <th class="uniformtableheader white--text" style="font-size: 13px; width: 170px; text-align: center">{{headers[5].text}}</th>
            <th class="uniformtableheader white--text" style="font-size: 13px; width: 170px; text-align: center">{{headers[6].text}}</th>
            <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[7].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="text-align:left; font-size: 12px">{{ props.item.sno }}</td>
          <td style="text-align:left; font-size: 12px">{{ props.item.comm_name }}</td>
          <td style="text-align:center; font-size: 12px">{{ props.item.vendor_emp_id }}</td>
          <td style="text-align:left; font-size: 12px">{{ props.item.emp_name }}</td>
          <td style="text-align:left; font-size: 12px">{{ props.item.emp_desig }}</td>
          <td style="text-align:center; font-size: 12px">{{ props.item.in_att_dt_time ? handy.formatDBDateTime(props.item.in_att_dt_time) : '-' }}</td>
          <td style="text-align:center; font-size: 12px">{{ props.item.out_att_dt_time ? handy.formatDBDateTime(props.item.out_att_dt_time) : '-' }}</td>
          <td style="text-align:center; font-size: 12px">{{ props.item.tot_hours ? props.item.tot_hours : '-' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>

</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      load: false,
      // payroll
      lAttDet: [],
      commList: [],
      empList: [],
      resignedEmpList: [],
      inactiveCommList: [],
      showAllEmp: false,
      dlgstartDt: false,
      dlgToDate: false,
      staffDet: [],
      staffDetHeader: [
        { text: 'Sno' , value: 'sno' },
        { text: 'Community Name' , value: 'comm_name', sortable: true },
        { text: 'Emp Id' , value: 'vendor_emp_id' },
        { text: 'Emp Name' , value: 'emp_name' },
        { text: 'Designation' , value: 'emp_desig' },
        { text: 'In Date Time' , value: 'in_att_dt_time' },
        { text: 'Out Date Time' , value: 'out_att_dt_time' },
        { text: 'Tot.Hours' , value: 'tot_hours' },
        { text: 'In Time' , value: 'in_time', visible: 'flase' }
      ],
      staffVisitDetails: [],
      commIds: [],
      commIdWiseStaffVisitDetails : [],
      empIds: [],
      empIdWiseStaffVisitDetails : [],
    }
  },
  created () {
    this.loadCommunity()
    this.lAttDet = this.getEmptyBOSiteDet()
    this.loadEmployee()
    var curDate = new Date()
    this.lAttDet.from_dt = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth(), 1))
    this.lAttDet.to_dt = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0))
  },
  computed: {
    selectAllComm () {
      if (this.lAttDet.category === 'Active') {
        return this.lAttDet.comm_id.length === this.commList.length
      } else {
        return this.lAttDet.comm_id.length === this.inactiveCommList.length
      }
    },
    selectSomeComm () {
      return this.lAttDet.comm_id.length > 0 && !this.selectAllComm
    },
    icon () {
      if (this.selectAllComm) return 'mdi-close-box'
      if (this.selectSomeComm) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    toggle () {
      this.$nextTick(() => {
        if (this.selectAllComm) {
          this.lAttDet.comm_id = []
        } else {
          if (this.lAttDet.category === 'Active') {
            this.lAttDet.comm_id = this.commList.slice()
          } else {
            this.lAttDet.comm_id = this.inactiveCommList.slice()
          }
        }
      })
    },
    getEmptyBOSiteDet () {
      var emptyBOSiteDet = {
        vendor_id: config.VENDOR_ID,
        category: 'Active',
        comm_id: [],
        vendor_emp_id: [],
        from_dt: null,
        to_dt: null
      }
      return emptyBOSiteDet
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.commList = []
      this.axios.get(config.API_URL + '/getProjectCommList/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.inactiveCommList = []
      this.axios.get(config.API_URL + '/getProjectInactiveCommList/', qry)
      .then(response => {
        this.inactiveCommList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadEmployee () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getBOSiteVisitBackOfficeStaffList/', qry)
      .then(response => {
        this.empList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadResignedEmployee (resignEmp) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          proj_status: resignEmp
        }
      }
      this.axios.get(config.API_URL + '/getBOSiteVisitBackOfficeStaffList/', qry)
      .then(response => {
        this.resignedEmpList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    SearchBOStaffSiteVisit () {
      if (!this.lAttDet.from_dt && !this.lAttDet.to_dt) {
        this.msg('Please select from date and to date', 0)
        return
      }
      var qry = {
        params: {
        }
      }
      qry.params = this.lAttDet
      console.log(this.lAttDet)
      qry.params.vendor_id = config.VENDOR_ID
      this.beingSaved = true
      this.staffVisitDetails = []
      this.axios.get(config.API_URL + '/getBOSiteVisitDetByStaffAndComm/', qry)
      .then(response => {
        this.staffDet = response.data
        if (!this.staffDet.length) {
          this.msg('No records found for given search criteria', 0)
        } else {
          // prepare the view based on the output from database Response
          var sno = 0
          var tot_records = this.staffDet.length
          this.staffDet.forEach((baseRec, i) => {
            baseRec.sortorder = i + 1
          })
          this.commIds = []
          this.commIds = handy.unique(this.staffDet.map(rec => rec.comm_id))
          this.commIds.forEach((commIdRec, j) => {
            this.commIdWiseStaffVisitDetails = []
            this.commIdWiseStaffVisitDetails = this.staffDet.filter(rec => rec.comm_id === commIdRec)

            this.empIds = []
            this.empIds = handy.unique(this.commIdWiseStaffVisitDetails.map(rec => rec.vendor_emp_id))
            this.empIds.forEach((empIdRec, k) => {
              this.empIdWiseStaffVisitDetails = []
              this.empIdWiseStaffVisitDetails = this.commIdWiseStaffVisitDetails.filter(rec => rec.vendor_emp_id === empIdRec)

              this.empIdWiseStaffVisitDetails.forEach((rec, v) => {
                if (v === 0 && rec.log_action === 'OUT') {
                  var qry = {
                    params: {
                      vendor_id: rec.vendor_id,
                      comm_id: rec.comm_id,
                      staff_id: rec.staff_id,
                      att_id: rec.att_id
                    }
                  }
                  this.axios.get(config.API_URL + '/getBOSiteVisitPreviousINRecord/', qry)
                  .then(response => {
                    var inRec = []
                    inRec = response.data[0]
                    let inDateTime = new Date(inRec.att_dt_time)
                    let outDateTime = new Date(rec.att_dt_time)
                    let seconds = Math.round((outDateTime.getTime() - inDateTime.getTime()))
                    let time_spent = new Date(seconds).toISOString().substr(11, 8)
                    sno += 1
                    this.staffVisitDetails.push({
                      sno: sno,
                      in_att_id: inRec.att_id,
                      out_att_id: rec.att_id,
                      comm_id: rec.comm_id,
                      comm_name: rec.comm_name,
                      staff_id: rec.staff_id,
                      vendor_emp_id: rec.vendor_emp_id,
                      emp_name: rec.emp_name,
                      emp_desig: rec.emp_desig,
                      att_dt: rec.att_dt,
                      in_att_dt_time: inRec.att_dt_time,
                      out_att_dt_time: rec.att_dt_time,
                      in_time: inRec.att_time,
                      out_time: rec.att_time,
                      tot_hours: time_spent,
                      vendor_id: rec.vendor_id
                    })
                  })
                } else {
                  if (rec.log_action === 'IN') {
                    var inRec = []
                    inRec = rec
                    var outRec = []
                    if (v + 1 <= this.empIdWiseStaffVisitDetails.length) {
                      outRec = this.empIdWiseStaffVisitDetails[v + 1]
                    }
                    let inDateTime = new Date(inRec.att_dt_time)
                    let outDateTime = ''
                    let seconds = 0
                    let time_spent = 0
                    let out_att_id = ''
                    let out_att_dt_time = ''
                    let out_time = ''
                    if (outRec) {
                      outDateTime = new Date(outRec.att_dt_time)
                      seconds = Math.round((outDateTime.getTime() - inDateTime.getTime()))
                      time_spent = new Date(seconds).toISOString().substr(11, 8)
                      out_att_id = outRec.att_id
                      out_att_dt_time = outRec.att_dt_time
                      out_time = outRec.att_time
                    }
                    sno += 1
                    this.staffVisitDetails.push({
                      sno: sno,
                      in_att_id: inRec.att_id,
                      out_att_id: out_att_id,
                      comm_id: inRec.comm_id,
                      comm_name: inRec.comm_name,
                      staff_id: inRec.staff_id,
                      vendor_emp_id: inRec.vendor_emp_id,
                      emp_name: inRec.emp_name,
                      emp_desig: inRec.emp_desig,
                      att_dt: inRec.att_dt,
                      in_att_dt_time: inRec.att_dt_time,
                      out_att_dt_time: out_att_dt_time,
                      in_time: inRec.att_time,
                      out_time: out_time,
                      tot_hours: time_spent,
                      vendor_id: inRec.vendor_id
                    })
                  }
                }
              })
            })
          })
        }
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.staffDet = []
        this.staffVisitDetails = []
        this.beingSaved = false
      })
    },
    clear () {
      this.lAttDet.comm_id = []
      this.lAttDet.vendor_emp_id = []
      this.lAttDet.from_dt = null
      this.lAttDet.to_dt = null
      this.lAttDet.category = 'Active'
      this.loadCommunity()
      this.staffDet = []
      this.staffVisitDetails = []
    }
  }
}
</script>
